import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import CONFIG from "../../../utils/config";
import { SessionKeys, clickStreamUser } from "../../../utils/AppUtils";
import {
  setIframeUserRole,
  userDetailBroker,
  userDetailIframeUser,
} from "../../../redux/user/actions";
import { loginIframeUserResponse } from "../../../redux/auth/actions";
import $ from "jquery";
import Loader from "../../Loader/Loader";
import _ from "lodash";
import useLogin from "../../../custom-hooks/useLogin";
import CoachingDetailPage from "./CoachingDetailPage";

const CoachingDetailPageMobile = () => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useLogin();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const key = params.get("key");
  const username = params.get("username");
  const user_id = params.get("user_id");
  const color_1 = params.get("color_1");
  const color_2 = params.get("color_2");
  const role = params.get("role");
  // const service_code = params.get("service_code");

  const [isLoading, setIsLoading] = useState(true);
  const [isValidKey, setIsValidKey] = useState(false);

  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  useEffect(() => {
    if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
      $("html").css(
        "--color-element-1",
        color_1 ? "#" + color_1 : CONFIG.COLOR_ELEMENT_1,
      );
      $("html").css(
        "--color-element-2",
        color_2 ? "#" + color_2 : CONFIG.COLOR_ELEMENT_2,
      );
      localStorage.setItem(SessionKeys.API_TOKEN, token);
      localStorage.setItem(SessionKeys.API_TOKEN_BROKER, token);
      localStorage.setItem(SessionKeys.USERNAME, username);
      setIsValidKey(true);
      if (role === "pmpro_membership_manager") {
        dispatch(setIframeUserRole("broker"));
      } else if (role === "broker_admin") {
        dispatch(setIframeUserRole("admin"));
      }

      setIsLoading(true);
      dispatch(
        loginIframeUserResponse({
          payload: {
            user: {
              user_id: user_id,
              username: username,
              email: username,
              role: [role],
            },
            apiToken: token,
          },
        }),
      );

      clickStreamUser("coaching_detail_mobile_page", {
        userId: user_id,
      });
      if (token) {
        dispatch(
          userDetailBroker({
            module: "getOrderDetailBroker",
            apiToken: token,
          }),
        );
      }
      setIsLoading(false);
    }
  }, [token, key, user_id, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Loader start={isLoading} />
      {isValidKey ? (
        <>
          <CoachingDetailPage isMobile={true} />
        </>
      ) : (
        <div>Invalid Key</div>
      )}
    </>
  );
};

export default CoachingDetailPageMobile;
